import React from 'react';
import './FeaturedProjects.css';
import FeaturedProject from './FeaturedProject';
import projectOneImg from '../assets/projectTwo/mainImg.jpg';
import projectTwoImg from '../assets/projectFour/mainImg.jpg';
import projectThreeImg from '../assets/projectFive/mainImg.jpg';

function featuredProjects(){
    return(
        <div className = "featured-projects">
            <h1>Istaknuti Projekti</h1>
            <div className = "featured-projects-container">
            <FeaturedProject
                imageSrc={projectOneImg}
                imageAlt="Istaknuti Projekat"
                projectID = "proj2"
            />
            <FeaturedProject
                imageSrc={projectTwoImg}
                imageAlt="Istaknuti Projekat"
                projectID = "proj4"
            />
            <FeaturedProject
                imageSrc={projectThreeImg}
                imageAlt="Istaknuti Projekat"
                projectID = "proj5"
            />
            </div>
        </div>
    );
}

export default featuredProjects;